import { authClient } from '@/lib/auth'

export function useAuth() {
  const { data: session, isPending } = authClient.useSession()

  const user = session?.user ?? null

  const handleSignOut = async () => {
    await authClient.signOut()
  }

  return {
    user,
    session,
    loading: isPending,
    signOut: handleSignOut,
    isAuthenticated: !!user,
  }
}

